// @ts-nocheck
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: protobuf_analytics_events/v1/tapestry.proto

/* eslint-disable */

export enum AdsManagerNavigationType {
  ADS_MANAGER_NAVIGATION_TYPE_UNSPECIFIED = "ADS_MANAGER_NAVIGATION_TYPE_UNSPECIFIED",
  ADS_MANAGER_NAVIGATION_TYPE_POP = "ADS_MANAGER_NAVIGATION_TYPE_POP",
  ADS_MANAGER_NAVIGATION_TYPE_PUSH = "ADS_MANAGER_NAVIGATION_TYPE_PUSH",
  ADS_MANAGER_NAVIGATION_TYPE_REPLACE = "ADS_MANAGER_NAVIGATION_TYPE_REPLACE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerAccountAccessStatus {
  ADS_MANAGER_ACCOUNT_ACCESS_STATUS_UNSPECIFIED = "ADS_MANAGER_ACCOUNT_ACCESS_STATUS_UNSPECIFIED",
  ADS_MANAGER_ACCOUNT_ACCESS_STATUS_READY = "ADS_MANAGER_ACCOUNT_ACCESS_STATUS_READY",
  ADS_MANAGER_ACCOUNT_ACCESS_STATUS_ACTIVATING = "ADS_MANAGER_ACCOUNT_ACCESS_STATUS_ACTIVATING",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerPendingInvitationActionType {
  ADS_MANAGER_PENDING_INVITATION_ACTION_TYPE_UNSPECIFIED = "ADS_MANAGER_PENDING_INVITATION_ACTION_TYPE_UNSPECIFIED",
  ADS_MANAGER_PENDING_INVITATION_ACTION_TYPE_ACCEPT = "ADS_MANAGER_PENDING_INVITATION_ACTION_TYPE_ACCEPT",
  ADS_MANAGER_PENDING_INVITATION_ACTION_TYPE_DECLINE = "ADS_MANAGER_PENDING_INVITATION_ACTION_TYPE_DECLINE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerPendingInvitationsCreateProjectClickSource {
  ADS_MANAGER_PENDING_INVITATIONS_CREATE_PROJECT_CLICK_SOURCE_UNSPECIFIED =
    "ADS_MANAGER_PENDING_INVITATIONS_CREATE_PROJECT_CLICK_SOURCE_UNSPECIFIED",
  ADS_MANAGER_PENDING_INVITATIONS_CREATE_PROJECT_CLICK_SOURCE_LIST =
    "ADS_MANAGER_PENDING_INVITATIONS_CREATE_PROJECT_CLICK_SOURCE_LIST",
  ADS_MANAGER_PENDING_INVITATIONS_CREATE_PROJECT_CLICK_SOURCE_ERROR_STATE =
    "ADS_MANAGER_PENDING_INVITATIONS_CREATE_PROJECT_CLICK_SOURCE_ERROR_STATE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerOnboardingStepType {
  ADS_MANAGER_ONBOARDING_STEP_TYPE_UNSPECIFIED = "ADS_MANAGER_ONBOARDING_STEP_TYPE_UNSPECIFIED",
  ADS_MANAGER_ONBOARDING_STEP_TYPE_BUSINESS = "ADS_MANAGER_ONBOARDING_STEP_TYPE_BUSINESS",
  ADS_MANAGER_ONBOARDING_STEP_TYPE_ACCOUNT = "ADS_MANAGER_ONBOARDING_STEP_TYPE_ACCOUNT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerOnboardingPublicLandingPageButton {
  ADS_MANAGER_ONBOARDING_PUBLIC_LANDING_PAGE_BUTTON_UNSPECIFIED =
    "ADS_MANAGER_ONBOARDING_PUBLIC_LANDING_PAGE_BUTTON_UNSPECIFIED",
  ADS_MANAGER_ONBOARDING_PUBLIC_LANDING_PAGE_BUTTON_LOG_IN = "ADS_MANAGER_ONBOARDING_PUBLIC_LANDING_PAGE_BUTTON_LOG_IN",
  ADS_MANAGER_ONBOARDING_PUBLIC_LANDING_PAGE_BUTTON_SIGN_UP =
    "ADS_MANAGER_ONBOARDING_PUBLIC_LANDING_PAGE_BUTTON_SIGN_UP",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerIdentityVerificationSurface {
  ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_UNSPECIFIED = "ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_UNSPECIFIED",
  ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_VERIFICATION_BANNER =
    "ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_VERIFICATION_BANNER",
  ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_CAMPAIGNS_NULL_STATE =
    "ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_CAMPAIGNS_NULL_STATE",
  ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_ONBOARDING_KICKOFF =
    "ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_ONBOARDING_KICKOFF",
  ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_ONBOARDING_POST_VERIFICATION_HOLDING =
    "ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_ONBOARDING_POST_VERIFICATION_HOLDING",
  ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_ONBOARDING_UNSUPPORTED_COUNTRY_HOLDING =
    "ADS_MANAGER_IDENTITY_VERIFICATION_SURFACE_ONBOARDING_UNSUPPORTED_COUNTRY_HOLDING",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerOnboardingAccountCreationOutcome {
  ADS_MANAGER_ONBOARDING_ACCOUNT_CREATION_OUTCOME_UNSPECIFIED =
    "ADS_MANAGER_ONBOARDING_ACCOUNT_CREATION_OUTCOME_UNSPECIFIED",
  ADS_MANAGER_ONBOARDING_ACCOUNT_CREATION_OUTCOME_SUCCEEDED =
    "ADS_MANAGER_ONBOARDING_ACCOUNT_CREATION_OUTCOME_SUCCEEDED",
  ADS_MANAGER_ONBOARDING_ACCOUNT_CREATION_OUTCOME_FAILED = "ADS_MANAGER_ONBOARDING_ACCOUNT_CREATION_OUTCOME_FAILED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerIdentityVerificationAction {
  ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_UNSPECIFIED = "ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_UNSPECIFIED",
  ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_SURFACE_SHOWN = "ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_SURFACE_SHOWN",
  ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_STATUS_LOAD = "ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_STATUS_LOAD",
  ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_START_CLICKED = "ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_START_CLICKED",
  ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_INQUIRY_CREATE = "ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_INQUIRY_CREATE",
  ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_PERSONA_OPEN = "ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_PERSONA_OPEN",
  ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_PERSONA_COMPLETE =
    "ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_PERSONA_COMPLETE",
  ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_BANNER_DISMISS = "ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_BANNER_DISMISS",
  ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_STATUS_CHECK = "ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_STATUS_CHECK",
  ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_HOLDING_STATUS_REFRESH =
    "ADS_MANAGER_IDENTITY_VERIFICATION_ACTION_HOLDING_STATUS_REFRESH",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerIdentityVerificationOutcome {
  ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_UNSPECIFIED = "ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_UNSPECIFIED",
  ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_VIEWED = "ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_VIEWED",
  ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_CLICKED = "ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_CLICKED",
  ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_SUCCEEDED = "ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_SUCCEEDED",
  ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_FAILED = "ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_FAILED",
  ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_COMPLETED = "ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_COMPLETED",
  ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_NOT_SUBMITTED = "ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_NOT_SUBMITTED",
  ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_DISMISSED = "ADS_MANAGER_IDENTITY_VERIFICATION_OUTCOME_DISMISSED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerBillingProfileSurface {
  ADS_MANAGER_BILLING_PROFILE_SURFACE_UNSPECIFIED = "ADS_MANAGER_BILLING_PROFILE_SURFACE_UNSPECIFIED",
  ADS_MANAGER_BILLING_PROFILE_SURFACE_OVERVIEW_NULL_STATE = "ADS_MANAGER_BILLING_PROFILE_SURFACE_OVERVIEW_NULL_STATE",
  ADS_MANAGER_BILLING_PROFILE_SURFACE_SETTINGS_NULL_STATE = "ADS_MANAGER_BILLING_PROFILE_SURFACE_SETTINGS_NULL_STATE",
  ADS_MANAGER_BILLING_PROFILE_SURFACE_SETTINGS_PAGE = "ADS_MANAGER_BILLING_PROFILE_SURFACE_SETTINGS_PAGE",
  ADS_MANAGER_BILLING_PROFILE_SURFACE_PROFILE_SETUP_MODAL = "ADS_MANAGER_BILLING_PROFILE_SURFACE_PROFILE_SETUP_MODAL",
  ADS_MANAGER_BILLING_PROFILE_SURFACE_LEFT_RAIL = "ADS_MANAGER_BILLING_PROFILE_SURFACE_LEFT_RAIL",
  ADS_MANAGER_BILLING_PROFILE_SURFACE_ONBOARDING_INLINE = "ADS_MANAGER_BILLING_PROFILE_SURFACE_ONBOARDING_INLINE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerBillingProfileMode {
  ADS_MANAGER_BILLING_PROFILE_MODE_UNSPECIFIED = "ADS_MANAGER_BILLING_PROFILE_MODE_UNSPECIFIED",
  ADS_MANAGER_BILLING_PROFILE_MODE_CREATE = "ADS_MANAGER_BILLING_PROFILE_MODE_CREATE",
  ADS_MANAGER_BILLING_PROFILE_MODE_EDIT = "ADS_MANAGER_BILLING_PROFILE_MODE_EDIT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerBillingProfileAction {
  ADS_MANAGER_BILLING_PROFILE_ACTION_UNSPECIFIED = "ADS_MANAGER_BILLING_PROFILE_ACTION_UNSPECIFIED",
  ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_PROMPT_SHOWN = "ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_PROMPT_SHOWN",
  ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_CLICKED = "ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_CLICKED",
  ADS_MANAGER_BILLING_PROFILE_ACTION_EDIT_CLICKED = "ADS_MANAGER_BILLING_PROFILE_ACTION_EDIT_CLICKED",
  ADS_MANAGER_BILLING_PROFILE_ACTION_MODAL_OPENED = "ADS_MANAGER_BILLING_PROFILE_ACTION_MODAL_OPENED",
  ADS_MANAGER_BILLING_PROFILE_ACTION_SAVE_CLICKED = "ADS_MANAGER_BILLING_PROFILE_ACTION_SAVE_CLICKED",
  ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_INTENT_CREATE = "ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_INTENT_CREATE",
  ADS_MANAGER_BILLING_PROFILE_ACTION_PAYMENT_METHOD_CREATE = "ADS_MANAGER_BILLING_PROFILE_ACTION_PAYMENT_METHOD_CREATE",
  ADS_MANAGER_BILLING_PROFILE_ACTION_ADDITIONAL_STRIPE_ACTION =
    "ADS_MANAGER_BILLING_PROFILE_ACTION_ADDITIONAL_STRIPE_ACTION",
  ADS_MANAGER_BILLING_PROFILE_ACTION_SAVE = "ADS_MANAGER_BILLING_PROFILE_ACTION_SAVE",
  ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_BADGE_SHOWN = "ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_BADGE_SHOWN",
  ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_INTENT_CONFIRM = "ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_INTENT_CONFIRM",
  ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_FORM_SHOWN = "ADS_MANAGER_BILLING_PROFILE_ACTION_SETUP_FORM_SHOWN",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerBillingProfileOutcome {
  ADS_MANAGER_BILLING_PROFILE_OUTCOME_UNSPECIFIED = "ADS_MANAGER_BILLING_PROFILE_OUTCOME_UNSPECIFIED",
  ADS_MANAGER_BILLING_PROFILE_OUTCOME_VIEWED = "ADS_MANAGER_BILLING_PROFILE_OUTCOME_VIEWED",
  ADS_MANAGER_BILLING_PROFILE_OUTCOME_CLICKED = "ADS_MANAGER_BILLING_PROFILE_OUTCOME_CLICKED",
  ADS_MANAGER_BILLING_PROFILE_OUTCOME_SUCCEEDED = "ADS_MANAGER_BILLING_PROFILE_OUTCOME_SUCCEEDED",
  ADS_MANAGER_BILLING_PROFILE_OUTCOME_FAILED = "ADS_MANAGER_BILLING_PROFILE_OUTCOME_FAILED",
  ADS_MANAGER_BILLING_PROFILE_OUTCOME_REQUIRED = "ADS_MANAGER_BILLING_PROFILE_OUTCOME_REQUIRED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerCreationWizardStage {
  ADS_MANAGER_CREATION_WIZARD_STAGE_UNSPECIFIED = "ADS_MANAGER_CREATION_WIZARD_STAGE_UNSPECIFIED",
  ADS_MANAGER_CREATION_WIZARD_STAGE_DIALOG_OPENED = "ADS_MANAGER_CREATION_WIZARD_STAGE_DIALOG_OPENED",
  ADS_MANAGER_CREATION_WIZARD_STAGE_FIRST_AD_GROUP_ADDED = "ADS_MANAGER_CREATION_WIZARD_STAGE_FIRST_AD_GROUP_ADDED",
  ADS_MANAGER_CREATION_WIZARD_STAGE_FIRST_AD_ADDED = "ADS_MANAGER_CREATION_WIZARD_STAGE_FIRST_AD_ADDED",
  ADS_MANAGER_CREATION_WIZARD_STAGE_REVIEW_REACHED = "ADS_MANAGER_CREATION_WIZARD_STAGE_REVIEW_REACHED",
  ADS_MANAGER_CREATION_WIZARD_STAGE_SUBMISSION = "ADS_MANAGER_CREATION_WIZARD_STAGE_SUBMISSION",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerCreationWizardSource {
  ADS_MANAGER_CREATION_WIZARD_SOURCE_UNSPECIFIED = "ADS_MANAGER_CREATION_WIZARD_SOURCE_UNSPECIFIED",
  ADS_MANAGER_CREATION_WIZARD_SOURCE_DIALOG = "ADS_MANAGER_CREATION_WIZARD_SOURCE_DIALOG",
  ADS_MANAGER_CREATION_WIZARD_SOURCE_ONBOARDING_SETUP = "ADS_MANAGER_CREATION_WIZARD_SOURCE_ONBOARDING_SETUP",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerCreationWizardOutcome {
  ADS_MANAGER_CREATION_WIZARD_OUTCOME_UNSPECIFIED = "ADS_MANAGER_CREATION_WIZARD_OUTCOME_UNSPECIFIED",
  ADS_MANAGER_CREATION_WIZARD_OUTCOME_SUCCEEDED = "ADS_MANAGER_CREATION_WIZARD_OUTCOME_SUCCEEDED",
  ADS_MANAGER_CREATION_WIZARD_OUTCOME_PARTIAL_FAILURE = "ADS_MANAGER_CREATION_WIZARD_OUTCOME_PARTIAL_FAILURE",
  ADS_MANAGER_CREATION_WIZARD_OUTCOME_FAILED = "ADS_MANAGER_CREATION_WIZARD_OUTCOME_FAILED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum TapestryPostCampaignSetupSource {
  TAPESTRY_POST_CAMPAIGN_SETUP_SOURCE_UNSPECIFIED = "TAPESTRY_POST_CAMPAIGN_SETUP_SOURCE_UNSPECIFIED",
  TAPESTRY_POST_CAMPAIGN_SETUP_SOURCE_POST_CAMPAIGN = "TAPESTRY_POST_CAMPAIGN_SETUP_SOURCE_POST_CAMPAIGN",
  TAPESTRY_POST_CAMPAIGN_SETUP_SOURCE_ACCOUNT_SETUP = "TAPESTRY_POST_CAMPAIGN_SETUP_SOURCE_ACCOUNT_SETUP",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum TapestryPostCampaignSetupStepType {
  TAPESTRY_POST_CAMPAIGN_SETUP_STEP_TYPE_UNSPECIFIED = "TAPESTRY_POST_CAMPAIGN_SETUP_STEP_TYPE_UNSPECIFIED",
  TAPESTRY_POST_CAMPAIGN_SETUP_STEP_TYPE_BILLING = "TAPESTRY_POST_CAMPAIGN_SETUP_STEP_TYPE_BILLING",
  TAPESTRY_POST_CAMPAIGN_SETUP_STEP_TYPE_LOGO = "TAPESTRY_POST_CAMPAIGN_SETUP_STEP_TYPE_LOGO",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerEligibilitySurface {
  ADS_MANAGER_ELIGIBILITY_SURFACE_UNSPECIFIED = "ADS_MANAGER_ELIGIBILITY_SURFACE_UNSPECIFIED",
  ADS_MANAGER_ELIGIBILITY_SURFACE_LEFT_RAIL = "ADS_MANAGER_ELIGIBILITY_SURFACE_LEFT_RAIL",
  ADS_MANAGER_ELIGIBILITY_SURFACE_SERVING_STATUS_POPOVER = "ADS_MANAGER_ELIGIBILITY_SURFACE_SERVING_STATUS_POPOVER",
  ADS_MANAGER_ELIGIBILITY_SURFACE_CREATION_ENTRYPOINT = "ADS_MANAGER_ELIGIBILITY_SURFACE_CREATION_ENTRYPOINT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerEligibilityAction {
  ADS_MANAGER_ELIGIBILITY_ACTION_UNSPECIFIED = "ADS_MANAGER_ELIGIBILITY_ACTION_UNSPECIFIED",
  ADS_MANAGER_ELIGIBILITY_ACTION_BADGE_SHOWN = "ADS_MANAGER_ELIGIBILITY_ACTION_BADGE_SHOWN",
  ADS_MANAGER_ELIGIBILITY_ACTION_BLOCKER_SHOWN = "ADS_MANAGER_ELIGIBILITY_ACTION_BLOCKER_SHOWN",
  ADS_MANAGER_ELIGIBILITY_ACTION_CREATE_AVAILABLE = "ADS_MANAGER_ELIGIBILITY_ACTION_CREATE_AVAILABLE",
  ADS_MANAGER_ELIGIBILITY_ACTION_CREATE_CLICKED = "ADS_MANAGER_ELIGIBILITY_ACTION_CREATE_CLICKED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerEligibilityRequirementType {
  ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_UNSPECIFIED = "ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_UNSPECIFIED",
  ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_BILLING = "ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_BILLING",
  ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_FAVICON = "ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_FAVICON",
  ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_IDENTITY_VERIFICATION =
    "ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_IDENTITY_VERIFICATION",
  ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_ACCESS_ACTIVATION =
    "ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_ACCESS_ACTIVATION",
  ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_PENDING_INVITATIONS =
    "ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_PENDING_INVITATIONS",
  ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_UNKNOWN = "ADS_MANAGER_ELIGIBILITY_REQUIREMENT_TYPE_UNKNOWN",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerLifecycleAction {
  ADS_MANAGER_LIFECYCLE_ACTION_UNSPECIFIED = "ADS_MANAGER_LIFECYCLE_ACTION_UNSPECIFIED",
  ADS_MANAGER_LIFECYCLE_ACTION_ENTERED_ADS_MANAGER = "ADS_MANAGER_LIFECYCLE_ACTION_ENTERED_ADS_MANAGER",
  ADS_MANAGER_LIFECYCLE_ACTION_ELIGIBLE_ACCOUNT_CREATED = "ADS_MANAGER_LIFECYCLE_ACTION_ELIGIBLE_ACCOUNT_CREATED",
  ADS_MANAGER_LIFECYCLE_ACTION_BILLING_AND_LOGO_SETUP_COMPLETED =
    "ADS_MANAGER_LIFECYCLE_ACTION_BILLING_AND_LOGO_SETUP_COMPLETED",
  ADS_MANAGER_LIFECYCLE_ACTION_CAMPAIGN_SERVING = "ADS_MANAGER_LIFECYCLE_ACTION_CAMPAIGN_SERVING",
  ADS_MANAGER_LIFECYCLE_ACTION_INTEGRITY_AND_INDUSTRY_GRADERS_PASSED =
    "ADS_MANAGER_LIFECYCLE_ACTION_INTEGRITY_AND_INDUSTRY_GRADERS_PASSED",
  ADS_MANAGER_LIFECYCLE_ACTION_BRAND_REVIEW_ACCEPTED = "ADS_MANAGER_LIFECYCLE_ACTION_BRAND_REVIEW_ACCEPTED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AdsManagerAutomaticAdvancedMatchingAction {
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_UNSPECIFIED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_UNSPECIFIED",
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_BANNER_VIEWED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_BANNER_VIEWED",
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_ENABLE_CLICKED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_ENABLE_CLICKED",
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_ENABLE_COMPLETED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_ENABLE_COMPLETED",
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_BANNER_DISMISSED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_BANNER_DISMISSED",
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_ENABLE_FAILED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_ENABLE_FAILED",
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_EXISTING_PIXEL_NOTICE_VIEWED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_EXISTING_PIXEL_NOTICE_VIEWED",
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_OPT_OUT_CLICKED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_OPT_OUT_CLICKED",
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_OPT_OUT_SUCCEEDED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_OPT_OUT_SUCCEEDED",
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_OPT_OUT_FAILED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_OPT_OUT_FAILED",
  ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_PIXEL_ENABLED =
    "ADS_MANAGER_AUTOMATIC_ADVANCED_MATCHING_ACTION_PIXEL_ENABLED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface AdsManagerRouteLoad {
  adAccountId?: string | undefined;
  route?: string | undefined;
  leafRouteId?: string | undefined;
  routeIds?: string[] | undefined;
  navigationType?: AdsManagerNavigationType | undefined;
  hasQuery?: boolean | undefined;
  hasHash?: boolean | undefined;
  isInitialLoad?: boolean | undefined;
  utmSource?: string | undefined;
  utmMedium?: string | undefined;
  utmCampaign?: string | undefined;
  utmContent?: string | undefined;
  utmTerm?: string | undefined;
}

export interface AdsManagerLifecycleEvent {
  adAccountId?: string | undefined;
  action?: AdsManagerLifecycleAction | undefined;
  route?: string | undefined;
  adAccountStatus?: string | undefined;
  createdAdAccountId?: string | undefined;
  tenantId?: string | undefined;
  advertiserType?: string | undefined;
  adAccountCountryCode?: string | undefined;
  accessStatus?: AdsManagerAccountAccessStatus | undefined;
  campaignId?: string | undefined;
  campaignStatus?: string | undefined;
}

export interface AdsManagerPendingInvitationsPageViewed {
  adAccountId?: string | undefined;
  invitationCount?: number | undefined;
}

export interface AdsManagerPendingInvitationsLoadFailed {
  adAccountId?: string | undefined;
  errorType?: string | undefined;
}

export interface AdsManagerPendingInvitationsCreateProjectClicked {
  adAccountId?: string | undefined;
  source?: AdsManagerPendingInvitationsCreateProjectClickSource | undefined;
}

export interface AdsManagerPendingInvitationMutationSucceeded {
  adAccountId?: string | undefined;
  tenantId?: string | undefined;
  actionType?: AdsManagerPendingInvitationActionType | undefined;
  accessStatus?: AdsManagerAccountAccessStatus | undefined;
}

export interface AdsManagerPendingInvitationMutationFailed {
  adAccountId?: string | undefined;
  tenantId?: string | undefined;
  actionType?: AdsManagerPendingInvitationActionType | undefined;
  errorType?: string | undefined;
}

export interface AdsManagerOnboardingPageViewed {
  adAccountId?: string | undefined;
  initialStepType?: AdsManagerOnboardingStepType | undefined;
}

export interface AdsManagerOnboardingPublicLandingPageView {
  adAccountId?: string | undefined;
  utmSource?: string | undefined;
  utmMedium?: string | undefined;
  utmCampaign?: string | undefined;
  utmContent?: string | undefined;
  utmTerm?: string | undefined;
  referrerUrl?: string | undefined;
}

export interface AdsManagerOnboardingPublicLandingPageButtonClicked {
  button?: AdsManagerOnboardingPublicLandingPageButton | undefined;
  utmSource?: string | undefined;
  utmMedium?: string | undefined;
  utmCampaign?: string | undefined;
  utmContent?: string | undefined;
  utmTerm?: string | undefined;
}

export interface AdsManagerOnboardingStepViewed {
  adAccountId?: string | undefined;
  stepType?: AdsManagerOnboardingStepType | undefined;
}

export interface AdsManagerOnboardingCreateAccountClicked {
  adAccountId?: string | undefined;
  shouldCreateTenant?: boolean | undefined;
  tenantsCount?: number | undefined;
}

export interface AdsManagerOnboardingAccountCreationSucceeded {
  adAccountId?: string | undefined;
  shouldCreateTenant?: boolean | undefined;
  tenantsCount?: number | undefined;
  tenantId?: string | undefined;
  createdAdAccountId?: string | undefined;
  accessStatus?: AdsManagerAccountAccessStatus | undefined;
}

export interface AdsManagerOnboardingAccountCreationFailed {
  adAccountId?: string | undefined;
  shouldCreateTenant?: boolean | undefined;
  tenantsCount?: number | undefined;
  tenantId?: string | undefined;
  errorType?: string | undefined;
}

export interface AdsManagerCreationWizardSucceeded {
  adAccountId?: string | undefined;
  adGroupsCreated?: number | undefined;
  adsCreated?: number | undefined;
}

export interface AdsManagerIdentityVerificationStatusLoaded {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
  verificationType?: string | undefined;
  approvedBannerDismissed?: boolean | undefined;
}

export interface AdsManagerIdentityVerificationStatusLoadFailed {
  adAccountId?: string | undefined;
  approvedBannerDismissed?: boolean | undefined;
  errorType?: string | undefined;
}

export interface AdsManagerIdentityVerificationBannerShown {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
  bannerTitle?: string | undefined;
  actionLabel?: string | undefined;
}

export interface AdsManagerIdentityVerificationStartClicked {
  adAccountId?: string | undefined;
  surface?: AdsManagerIdentityVerificationSurface | undefined;
  verificationStatus?: string | undefined;
  actionLabel?: string | undefined;
}

export interface AdsManagerIdentityVerificationBannerDismissed {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
  bannerTitle?: string | undefined;
}

export interface AdsManagerIdentityVerificationNullStateShown {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
}

export interface AdsManagerIdentityVerificationInquiryCreated {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
  verificationType?: string | undefined;
  previousVerificationStatus?: string | undefined;
}

export interface AdsManagerIdentityVerificationInquiryCreateFailed {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
  errorType?: string | undefined;
}

export interface AdsManagerIdentityVerificationPersonaOpened {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
  verificationType?: string | undefined;
}

export interface AdsManagerIdentityVerificationPersonaOpenFailed {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
  errorType?: string | undefined;
}

export interface AdsManagerIdentityVerificationPersonaCompleted {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
  verificationType?: string | undefined;
}

export interface AdsManagerIdentityVerificationBannerDismissSucceeded {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
  dismissed?: boolean | undefined;
}

export interface AdsManagerIdentityVerificationBannerDismissFailed {
  adAccountId?: string | undefined;
  verificationStatus?: string | undefined;
  errorType?: string | undefined;
}

export interface AdsManagerOnboardingAccountCreationEvent {
  adAccountId?: string | undefined;
  outcome?: AdsManagerOnboardingAccountCreationOutcome | undefined;
  shouldCreateTenant?: boolean | undefined;
  tenantsCount?: number | undefined;
  tenantId?: string | undefined;
  createdAdAccountId?: string | undefined;
  accessStatus?: AdsManagerAccountAccessStatus | undefined;
  errorType?: string | undefined;
  errorCode?: string | undefined;
  httpStatus?: number | undefined;
  errorMessage?: string | undefined;
}

export interface AdsManagerIdentityVerificationEvent {
  adAccountId?: string | undefined;
  surface?: AdsManagerIdentityVerificationSurface | undefined;
  action?: AdsManagerIdentityVerificationAction | undefined;
  outcome?: AdsManagerIdentityVerificationOutcome | undefined;
  verificationStatus?: string | undefined;
  verificationType?: string | undefined;
  previousVerificationStatus?: string | undefined;
  approvedBannerDismissed?: boolean | undefined;
  dismissed?: boolean | undefined;
  bannerTitle?: string | undefined;
  actionLabel?: string | undefined;
  errorType?: string | undefined;
  errorCode?: string | undefined;
  httpStatus?: number | undefined;
  errorMessage?: string | undefined;
}

export interface AdsManagerBillingProfileEvent {
  adAccountId?: string | undefined;
  surface?: AdsManagerBillingProfileSurface | undefined;
  mode?: AdsManagerBillingProfileMode | undefined;
  action?: AdsManagerBillingProfileAction | undefined;
  outcome?: AdsManagerBillingProfileOutcome | undefined;
  canManageBilling?: boolean | undefined;
  isSetup?: boolean | undefined;
  errorType?: string | undefined;
  errorCode?: string | undefined;
  httpStatus?: number | undefined;
  errorMessage?: string | undefined;
  billingSetupAttemptId?: string | undefined;
}

export interface AdsManagerCreationWizardEvent {
  adAccountId?: string | undefined;
  stage?: AdsManagerCreationWizardStage | undefined;
  outcome?: AdsManagerCreationWizardOutcome | undefined;
  campaignId?: string | undefined;
  adGroupsCreated?: number | undefined;
  adGroupsFailed?: number | undefined;
  adsCreated?: number | undefined;
  adsFailed?: number | undefined;
  issuesCount?: number | undefined;
  errorType?: string | undefined;
  errorCode?: string | undefined;
  httpStatus?: number | undefined;
  errorMessage?: string | undefined;
  creativeHeadlinePrefilledCount?: number | undefined;
  creativeHeadlineChangedCount?: number | undefined;
  creativeImagePrefilledCount?: number | undefined;
  creativeImageChangedCount?: number | undefined;
  source?: AdsManagerCreationWizardSource | undefined;
}

export interface TapestryPostCampaignSetupStepCompleted {
  adAccountId?: string | undefined;
  source?: TapestryPostCampaignSetupSource | undefined;
  stepType?: TapestryPostCampaignSetupStepType | undefined;
}

export interface AdsManagerEligibilityEvent {
  adAccountId?: string | undefined;
  surface?: AdsManagerEligibilitySurface | undefined;
  action?: AdsManagerEligibilityAction | undefined;
  requirementType?: AdsManagerEligibilityRequirementType | undefined;
  blockerReasonCode?: string | undefined;
  canManageAdEntities?: boolean | undefined;
  createEntitiesInlineEnabled?: boolean | undefined;
  campaignCreationWizardEnabled?: boolean | undefined;
}

export interface AdsManagerAutomaticAdvancedMatchingEvent {
  adAccountId?: string | undefined;
  action?: AdsManagerAutomaticAdvancedMatchingAction | undefined;
  eligibleCount?: number | undefined;
  enabledCount?: number | undefined;
  failedCount?: number | undefined;
}

export const AdsManagerRouteLoad: MessageFns<AdsManagerRouteLoad, "protobuf_analytics_events.v1.AdsManagerRouteLoad"> =
  { $type: "protobuf_analytics_events.v1.AdsManagerRouteLoad" as const };

export const AdsManagerLifecycleEvent: MessageFns<
  AdsManagerLifecycleEvent,
  "protobuf_analytics_events.v1.AdsManagerLifecycleEvent"
> = { $type: "protobuf_analytics_events.v1.AdsManagerLifecycleEvent" as const };

export const AdsManagerPendingInvitationsPageViewed: MessageFns<
  AdsManagerPendingInvitationsPageViewed,
  "protobuf_analytics_events.v1.AdsManagerPendingInvitationsPageViewed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerPendingInvitationsPageViewed" as const };

export const AdsManagerPendingInvitationsLoadFailed: MessageFns<
  AdsManagerPendingInvitationsLoadFailed,
  "protobuf_analytics_events.v1.AdsManagerPendingInvitationsLoadFailed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerPendingInvitationsLoadFailed" as const };

export const AdsManagerPendingInvitationsCreateProjectClicked: MessageFns<
  AdsManagerPendingInvitationsCreateProjectClicked,
  "protobuf_analytics_events.v1.AdsManagerPendingInvitationsCreateProjectClicked"
> = { $type: "protobuf_analytics_events.v1.AdsManagerPendingInvitationsCreateProjectClicked" as const };

export const AdsManagerPendingInvitationMutationSucceeded: MessageFns<
  AdsManagerPendingInvitationMutationSucceeded,
  "protobuf_analytics_events.v1.AdsManagerPendingInvitationMutationSucceeded"
> = { $type: "protobuf_analytics_events.v1.AdsManagerPendingInvitationMutationSucceeded" as const };

export const AdsManagerPendingInvitationMutationFailed: MessageFns<
  AdsManagerPendingInvitationMutationFailed,
  "protobuf_analytics_events.v1.AdsManagerPendingInvitationMutationFailed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerPendingInvitationMutationFailed" as const };

export const AdsManagerOnboardingPageViewed: MessageFns<
  AdsManagerOnboardingPageViewed,
  "protobuf_analytics_events.v1.AdsManagerOnboardingPageViewed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerOnboardingPageViewed" as const };

export const AdsManagerOnboardingPublicLandingPageView: MessageFns<
  AdsManagerOnboardingPublicLandingPageView,
  "protobuf_analytics_events.v1.AdsManagerOnboardingPublicLandingPageView"
> = { $type: "protobuf_analytics_events.v1.AdsManagerOnboardingPublicLandingPageView" as const };

export const AdsManagerOnboardingPublicLandingPageButtonClicked: MessageFns<
  AdsManagerOnboardingPublicLandingPageButtonClicked,
  "protobuf_analytics_events.v1.AdsManagerOnboardingPublicLandingPageButtonClicked"
> = { $type: "protobuf_analytics_events.v1.AdsManagerOnboardingPublicLandingPageButtonClicked" as const };

export const AdsManagerOnboardingStepViewed: MessageFns<
  AdsManagerOnboardingStepViewed,
  "protobuf_analytics_events.v1.AdsManagerOnboardingStepViewed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerOnboardingStepViewed" as const };

export const AdsManagerOnboardingCreateAccountClicked: MessageFns<
  AdsManagerOnboardingCreateAccountClicked,
  "protobuf_analytics_events.v1.AdsManagerOnboardingCreateAccountClicked"
> = { $type: "protobuf_analytics_events.v1.AdsManagerOnboardingCreateAccountClicked" as const };

export const AdsManagerOnboardingAccountCreationSucceeded: MessageFns<
  AdsManagerOnboardingAccountCreationSucceeded,
  "protobuf_analytics_events.v1.AdsManagerOnboardingAccountCreationSucceeded"
> = { $type: "protobuf_analytics_events.v1.AdsManagerOnboardingAccountCreationSucceeded" as const };

export const AdsManagerOnboardingAccountCreationFailed: MessageFns<
  AdsManagerOnboardingAccountCreationFailed,
  "protobuf_analytics_events.v1.AdsManagerOnboardingAccountCreationFailed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerOnboardingAccountCreationFailed" as const };

export const AdsManagerCreationWizardSucceeded: MessageFns<
  AdsManagerCreationWizardSucceeded,
  "protobuf_analytics_events.v1.AdsManagerCreationWizardSucceeded"
> = { $type: "protobuf_analytics_events.v1.AdsManagerCreationWizardSucceeded" as const };

export const AdsManagerIdentityVerificationStatusLoaded: MessageFns<
  AdsManagerIdentityVerificationStatusLoaded,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationStatusLoaded"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationStatusLoaded" as const };

export const AdsManagerIdentityVerificationStatusLoadFailed: MessageFns<
  AdsManagerIdentityVerificationStatusLoadFailed,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationStatusLoadFailed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationStatusLoadFailed" as const };

export const AdsManagerIdentityVerificationBannerShown: MessageFns<
  AdsManagerIdentityVerificationBannerShown,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationBannerShown"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationBannerShown" as const };

export const AdsManagerIdentityVerificationStartClicked: MessageFns<
  AdsManagerIdentityVerificationStartClicked,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationStartClicked"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationStartClicked" as const };

export const AdsManagerIdentityVerificationBannerDismissed: MessageFns<
  AdsManagerIdentityVerificationBannerDismissed,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationBannerDismissed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationBannerDismissed" as const };

export const AdsManagerIdentityVerificationNullStateShown: MessageFns<
  AdsManagerIdentityVerificationNullStateShown,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationNullStateShown"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationNullStateShown" as const };

export const AdsManagerIdentityVerificationInquiryCreated: MessageFns<
  AdsManagerIdentityVerificationInquiryCreated,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationInquiryCreated"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationInquiryCreated" as const };

export const AdsManagerIdentityVerificationInquiryCreateFailed: MessageFns<
  AdsManagerIdentityVerificationInquiryCreateFailed,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationInquiryCreateFailed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationInquiryCreateFailed" as const };

export const AdsManagerIdentityVerificationPersonaOpened: MessageFns<
  AdsManagerIdentityVerificationPersonaOpened,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationPersonaOpened"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationPersonaOpened" as const };

export const AdsManagerIdentityVerificationPersonaOpenFailed: MessageFns<
  AdsManagerIdentityVerificationPersonaOpenFailed,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationPersonaOpenFailed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationPersonaOpenFailed" as const };

export const AdsManagerIdentityVerificationPersonaCompleted: MessageFns<
  AdsManagerIdentityVerificationPersonaCompleted,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationPersonaCompleted"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationPersonaCompleted" as const };

export const AdsManagerIdentityVerificationBannerDismissSucceeded: MessageFns<
  AdsManagerIdentityVerificationBannerDismissSucceeded,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationBannerDismissSucceeded"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationBannerDismissSucceeded" as const };

export const AdsManagerIdentityVerificationBannerDismissFailed: MessageFns<
  AdsManagerIdentityVerificationBannerDismissFailed,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationBannerDismissFailed"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationBannerDismissFailed" as const };

export const AdsManagerOnboardingAccountCreationEvent: MessageFns<
  AdsManagerOnboardingAccountCreationEvent,
  "protobuf_analytics_events.v1.AdsManagerOnboardingAccountCreationEvent"
> = { $type: "protobuf_analytics_events.v1.AdsManagerOnboardingAccountCreationEvent" as const };

export const AdsManagerIdentityVerificationEvent: MessageFns<
  AdsManagerIdentityVerificationEvent,
  "protobuf_analytics_events.v1.AdsManagerIdentityVerificationEvent"
> = { $type: "protobuf_analytics_events.v1.AdsManagerIdentityVerificationEvent" as const };

export const AdsManagerBillingProfileEvent: MessageFns<
  AdsManagerBillingProfileEvent,
  "protobuf_analytics_events.v1.AdsManagerBillingProfileEvent"
> = { $type: "protobuf_analytics_events.v1.AdsManagerBillingProfileEvent" as const };

export const AdsManagerCreationWizardEvent: MessageFns<
  AdsManagerCreationWizardEvent,
  "protobuf_analytics_events.v1.AdsManagerCreationWizardEvent"
> = { $type: "protobuf_analytics_events.v1.AdsManagerCreationWizardEvent" as const };

export const TapestryPostCampaignSetupStepCompleted: MessageFns<
  TapestryPostCampaignSetupStepCompleted,
  "protobuf_analytics_events.v1.TapestryPostCampaignSetupStepCompleted"
> = { $type: "protobuf_analytics_events.v1.TapestryPostCampaignSetupStepCompleted" as const };

export const AdsManagerEligibilityEvent: MessageFns<
  AdsManagerEligibilityEvent,
  "protobuf_analytics_events.v1.AdsManagerEligibilityEvent"
> = { $type: "protobuf_analytics_events.v1.AdsManagerEligibilityEvent" as const };

export const AdsManagerAutomaticAdvancedMatchingEvent: MessageFns<
  AdsManagerAutomaticAdvancedMatchingEvent,
  "protobuf_analytics_events.v1.AdsManagerAutomaticAdvancedMatchingEvent"
> = { $type: "protobuf_analytics_events.v1.AdsManagerAutomaticAdvancedMatchingEvent" as const };

interface MessageFns<T, V extends string> {
  readonly $type: V;

  readonly __payloadType?: T;
}
